import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=00202237&scoped=true"
import script from "./PartnerCard.vue?vue&type=script&lang=ts"
export * from "./PartnerCard.vue?vue&type=script&lang=ts"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&id=00202237&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00202237",
  null
  
)

export default component.exports